import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { Button } from './ui/button';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRoles }) => {
  const { isAuthenticated, user, getProfile, isLoading, error } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Токен есть, но профиль не загрузился (например, сеть/таймаут).
  if (!user) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-card border border-border rounded-lg p-6 space-y-3">
          <div className="text-lg font-semibold text-foreground">Не удалось загрузить данные</div>
          <div className="text-sm text-muted-foreground">
            {error || 'Проверьте соединение с сервером и попробуйте снова.'}
          </div>
          <div className="flex gap-2 pt-2">
            <Button
              onClick={() => {
                getProfile().catch(() => {});
              }}
              disabled={isLoading}
            >
              {isLoading ? 'Загрузка...' : 'Повторить'}
            </Button>
            <Button variant="outline" onClick={() => window.location.reload()}>
              Обновить страницу
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (requiredRoles && user && !requiredRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;